'use client';
import { useSignInController } from './use-sign-in-controller';
import type { SignInFormProps } from './use-sign-in-state';
import { SignInCredentialsView } from './sign-in-credentials-view';
import { SignInVerificationView } from './sign-in-verification-view';
export function SignInForm(props: SignInFormProps) {
  const model = useSignInController(props);
  return model.step === 'signIn' ? (
    <SignInCredentialsView {...model} />
  ) : (
    <SignInVerificationView {...model} />
  );
}
